<ng-template #defaultItemTemplate let-item="item" let-onCollapseExpand="onCollapseExpand"
    let-onCheckedChange="onCheckedChange">
    <div class="row-item">
        <fa-icon
            *ngIf="item.children"
            (click)="onCollapseExpand()"
            aria-hidden="true"
            class="si-treeview-icon"
            [fixedWidth]="true"
            [icon]="item.collapsed ? ['fas', 'caret-right'] : ['fas', 'caret-down']"
        ></fa-icon>
        <div class="form-check flex pl-0 pt-1 justify-start">
            <mat-checkbox
                [(ngModel)]="item.checked"
                [disabled]="item.disabled || (config.isParentToggleDisabled && item.children && item.checked !== true)"
                [indeterminate]="item.indeterminate"
                (ngModelChange)="onCheckedChange()"
                [matTooltip]="(item.disabled || (config.isParentToggleDisabled && item.children && item.checked !== true)) ? config.tooltip : (config.forceTooltip ? item.text : '')"
            ></mat-checkbox>
            <label
                class="form-check-label ml-2"
                (click)="onLabelClick(item, onCheckedChange)"
                [style.pointer-events]="(item.disabled || (config.isParentToggleDisabled && item.children && item.checked !== true)) ? 'none' : null"
                [matTooltip]="(item.disabled || (config.isParentToggleDisabled && item.children && item.checked !== true)) ? config.tooltip : (config.forceTooltip ? item.text : '')"
            >
                {{item.text}}
            </label>
        </div>
    </div>
</ng-template>
<ng-template #defaultHeaderTemplate let-config="config" let-item="item" let-onCollapseExpand="onCollapseExpand"
    let-onCheckedChange="onCheckedChange" let-onFilterTextChange="onFilterTextChange">
    <div *ngIf="config.hasFilter" class="flex flex-wrap -mx-1 row-filter gap-0">
      <div class="flex-none w-full px-1">
        <mat-form-field appearance="outline" class="mb-2 w-full no-padding">
            <mat-label>{{i18n.getFilterPlaceholder(config.label)}}</mat-label>
            <input matInput type="text" [placeholder]="i18n.getFilterPlaceholder(config.label)"
                   [(ngModel)]="filterText" (ngModelChange)="onFilterTextChange($event)"
                   (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"
                   (keyup.enter)="$event.preventDefault(); $event.stopPropagation()" />
            <button *ngIf="filterText" matSuffix matIconButton aria-label="Clear" (click)="onClear()">
                <fa-icon class="si-icon" [icon]="['fal', 'xmark']"></fa-icon>
            </button>
        </mat-form-field>
      </div>
    </div>

    <div *ngIf="config.hasClearAllButton" class="flex justify-end mb-2">
        <small class="a z-index" (click)="clearTree()">Clear all</small>
    </div>

    <div *ngIf="hasFilterItems" class="px-1">
        <div *ngIf="config.hasAllCheckBox || config.hasCollapseExpand" class="flex flex-wrap -mx-2 row-all">
            <div class="flex-none w-full px-2">
                <mat-checkbox
                    *ngIf="config.hasAllCheckBox"
                    [(ngModel)]="item.checked"
                    [disabled]="config.isAllToggleDisabled"
                    [indeterminate]="item.indeterminate"
                    (ngModelChange)="onCheckedChange()"
                    [matTooltip]="config.isAllToggleDisabled ? config.tooltip : (config.forceTooltip ? item.text : '')"
                >{{item.checked ? 'Select None' : allCheckboxText}} <ng-container *ngIf="totalLeavesCount > 0">({{ totalLeavesCount }})</ng-container></mat-checkbox>
                <label *ngIf="config.hasCollapseExpand" class="float-right cursor-pointer"
                    (click)="onCollapseExpand()"
                    [matTooltip]="config.forceTooltip ? item.text : ''"
                >
                    <fa-icon
                        [title]="i18n.getTooltipCollapseExpandText(item.collapsed)"
                        aria-hidden="true"
                        class="si-treeview-icon"
                        [fixedWidth]="true"
                        [icon]="item.collapsed ? ['fas', 'expand'] : ['fas', 'compress']"
                    ></fa-icon>
                </label>
            </div>
        </div>
        <div *ngIf="config.hasDivider" class="treeview-divider"></div>
    </div>
</ng-template>
<ng-template #virtualScrollItemsContainer>
    <div class="treeview-body">
        <div class="viewport treeview-container px-1 pt-1">
            <ngx-treeview-item *uiScroll="let item of datasource" [config]="config" [item]="item"
                [matTooltip]="item.disabled ? config.tooltip : (config.forceTooltip ? item.text : '')"
                [template]="itemTemplate || defaultItemTemplate"
                (checkedChange)="onItemCheckedChange(item, $event)">
            </ngx-treeview-item>
        </div>
    </div>
</ng-template>
<div class="treeview-header" data-html-to-image-ignore="true">
    <ng-template [ngTemplateOutlet]="headerTemplate || defaultHeaderTemplate"
        [ngTemplateOutletContext]="headerTemplateContext">
    </ng-template>
</div>
<ng-container *ngIf="!config?.virtualScrollEnabled; else virtualScrollItemsContainer">
    <div [ngSwitch]="hasFilterItems" class="treeview-body">
            <div *ngSwitchCase="true"
                 class="treeview-container px-1 pt-1"
                 [class.treeview-border-container]="config.hasBorder"
                 [class.py-2]="config.hasBorder"
                 [class.px-2]="config.hasBorder"
                 [class.ml-4]="config.hasContainerLeftMargin"
            >
                <!-- border -->
                <ngx-treeview-item *ngFor="let item of filterItems" [config]="config" [item]="item" [ngStyle]="{'padding-left': item.text === 'Cross Functional' ? '15px' : '0px'}"
                    [template]="itemTemplate || defaultItemTemplate" (checkedChange)="onItemCheckedChange(item, $event)">
                </ngx-treeview-item>
            </div>
            <div *ngSwitchCase="false" class="treeview-text">
                {{i18n.getFilterNoItemsFoundText(config.notextFound)}}
            </div>
    </div>
</ng-container>
